<script>
export default {
  name: 'view-runner',
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      specs: {
        wheel_size: null,
        color: null,
        tube_length: null,
        table_system: null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...v }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <h6 class="mt-4">{{ $t('specifications') }}</h6>
      <p class="p-0 my-2 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.wheel_size.key`) }}: </i>
        {{ $t(`attribute.wheel_size.value`, { value: specs.wheel_size }) }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.color.key`) }}: </i>
        {{
          $t(`attribute.color.value`, {
            value: specs.color
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.tube_length.key`) }}: </i>
        {{
          $t(`attribute.tube_length.value`, {
            value: specs.tube_length
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.table_system.key`) }}: </i>
        {{
          $t(`attribute.table_system.value`, {
            value: $t(`attribute.table_system.${specs.table_system}`)
          })
        }}
      </p>
    </b-col>
  </b-row>
</template>
